export default __webpack_public_path__ + "static/media/hero_business.6224fa75.png";